
[...document.querySelectorAll("#agreement-content")].forEach((ac) => {
  const checkboxes = [...ac.querySelectorAll(`input[type="checkbox"]`)];
  const button = jQuery(ac).closest("form").find(`button[name="next"]`).get(0);
  function update() {
    let checked = -1;
    checkboxes.forEach((cb, i) => {
      if (cb.checked) {
        checked = Math.max(checked, i);
      }
    });
    checkboxes.forEach((cb, i) => {
      if (i <= checked + 1) {
        jQuery(cb).siblings("label").addClass("checkable");
        cb.disabled = false;
      } else {
        jQuery(cb).siblings("label").removeClass("checkable");
        cb.disabled = true;
      }
    });

    button.disabled = checked !== checkboxes.length - 1;
  }

  update();
  checkboxes.forEach((cb) => {
    cb.addEventListener("change", update);
  });
});  
